import React from 'react';
import { offerAnchor, volumes } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-274" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-3xl" data-id="element-275" data-mp="185q1lqmmm3tb">
        <Eyebrow data-id="element-276" data-mp="1c4ywwzxbe9qz">What's included</Eyebrow>
        <SectionTitle data-id="element-277" data-mp="1c607l3af4u86">
          5 complete <Mark data-id="element-278" data-mp="1zv1nfblkz7nh">professional volumes</Mark>
        </SectionTitle>

        <ul className="mt-8 space-y-4" data-id="element-279" data-mp="1zvkws3x60npw">
          {volumes.map(volume => <li key={volume.number} className="overflow-hidden rounded-2xl border border-teal-800/10 shadow-sm" data-id="element-280" data-mp="24t31tj82aism">
              <div className="flex items-center gap-3 bg-teal-800 px-4 py-3 md:px-5" data-id="element-281" data-mp="1qtv1gn05x4mu">
                <span className="shrink-0 rounded-md bg-amber-400 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-teal-950 md:text-[11px]" data-id="element-282" data-mp="1vs4y721jcdak">
                  Volume {volume.number}
                </span>
                <h3 className="text-sm font-black uppercase leading-tight text-white md:text-base" data-id="element-283" data-mp="kfm31xoaou96">{volume.name}</h3>
              </div>
              <div className="bg-white px-4 py-4 md:px-5" data-id="element-284" data-mp="3j9btuignopba">
                <p className="text-sm font-semibold leading-relaxed text-teal-950" data-id="element-285" data-mp="3jawpycimcgb9">{volume.intro}</p>
                {volume.items && <>
                    {volume.itemsLabel && <p className="mt-3 text-[11px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-286" data-mp="3t9chgglk5rla">
                        {volume.itemsLabel}
                      </p>}
                    <ul className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-287" data-mp="60h86nbx6snu">
                      {volume.items.map(item => <li key={item} className="rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700" data-id="element-288" data-mp="fsd53v29scqh">
                          {item}
                        </li>)}
                    </ul>
                  </>}
                <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-289" data-mp="psdspt769f0h">{volume.details}</p>
                {volume.note && <p className="mt-2 rounded-md border-l-4 border-amber-400 bg-amber-50 px-3 py-2 text-xs font-semibold leading-relaxed text-amber-900" data-id="element-290" data-mp="11su0xypmu8x7">
                    {volume.note}
                  </p>}
                <p className="mt-3 text-[11px] font-black uppercase tracking-wider text-teal-700" data-id="element-291" data-mp="1bivligis197d">{volume.tagline}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-292" data-mp="1kj1xtz2qo34y">
          <Button href={offerAnchor} size="lg" subtext="Get all 5 volumes + 5 free bonuses at today's launch price" data-id="element-293" data-mp="1khqsvvxk4pc9">
            Yes! Unlock all 5 volumes now
          </Button>
        </div>
      </div>
    </section>;
}